import { useClient } from '@composables/use-clients';
import {
  GetRequestArgsType,
  PostRequestArgsType,
} from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type SkillTreeEditorBatchUpdateSerialzierType = {
  tenantUserIds: Array<number>;
};

export type GetSkillTreeEditorsArgsType = GetRequestArgsType & {
  skillTreeCode: string;
  skillTreeEditorId?: number | null;
};

export type BatchUpdateSkillTreeEditorsArgsType = (
  PostRequestArgsType<SkillTreeEditorBatchUpdateSerialzierType> & {
    skillTreeCode: string;
  }
);

export const apiFetchSkillTreeEditors = async ({
  domain = useTenantStore().domain,
  skillTreeCode,
  skillTreeEditorId = null,
  query = {},
  errorConfig = {},
  callbacks = {},
}: GetSkillTreeEditorsArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.skillTreeEditors({ domain, skillTreeCode, skillTreeEditorId }),
      query,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiBatchUpdateSkillTreeEditors = async ({
  domain = useTenantStore().domain,
  skillTreeCode,
  payload,
  errorConfig = {},
  callbacks = {},
}: BatchUpdateSkillTreeEditorsArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.skillTreeEditorsBatchUpdate({ domain, skillTreeCode }),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
